import { useEffect, useContext } from 'react';

import { SubmittalsContext } from '../components/Provider';

export default function useSpecs() {
  const {
    specs: { data, isLoading, error, fetchSpecs },
  } = useContext(SubmittalsContext);

  // fetching is done here instead of in the provider in order to no interfere
  // other modules with loading a long list as it loads.
  useEffect(fetchSpecs, [fetchSpecs]);

  return { specs: data, isLoading, error };
}
